module.exports = __webpack_public_path__ + "03_glasses_red.fe7504c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/03_glasses_red.png
// module id = m5mn
// module chunks = 0